'use strict';
import '../../sass/error.scss';

export function KaguraException(reason) {
  this.reason = reason || '不明なエラーが発生しました。';
}
KaguraException.prototype.create = function() {
  var df = document.createDocumentFragment();
  var content = document.createElement('div');
  content.id = 'merchandise-error';
  content.className = 'content_width clearfix';
  df.appendChild(content);

  var leftSection = content.cloneNode(false);
  leftSection.removeAttribute('id');
  leftSection.className = 'block04';
  df.firstChild.appendChild(leftSection);

  var rightSection = leftSection.cloneNode(false);
  rightSection.className = 'block03';
  df.firstChild.appendChild(rightSection);

  var headline = document.createElement('h1');
  var headlineImage = document.createElement('img');
  headlineImage.src = '../img/pic_relation_topic.png';
  headlineImage.alt = '関連商品';
  headlineImage.width = 180;
  headlineImage.height = 69;
  headline.appendChild(headlineImage);
  df.querySelector('.block04').appendChild(headline);

  var container = content.cloneNode(false);
  container.removeAttribute('id');
  container.className = 'container container--merchandise';
  df.querySelector('.block04').appendChild(container);

  var para = document.createElement('p');
  para.className = 'kgr-merchandise__paragraph';
  para.className += ' kgr-merchandise__paragraph--error-message';
  para.textContent = '該当する関連商品情報が取得できませんでした。';
  console.error(this.reason);
  df.querySelector('.container--merchandise').appendChild(para);
  return df;
};